export const formatSchemaType = (schemaType: string) =>
  schemaType
    .split(/-/)
    .reverse()
    .map((chunk, idx) => `${idx === 0 ? 'F' : ''}${chunk.charAt(0).toUpperCase()}${chunk.slice(1)}`)
    .join('');
